import SymbolMascotSideways from "@/components/symbols/mascot/sideways.vue";
export default {
    name: 'ModalSpeechBubble',
    components: { SymbolMascotSideways },
};
